import { create } from 'zustand';

export type DownloadExportKind =
  | 'dicom'
  | 'jpeg-current'
  | 'jpeg-study'
  | 'jpeg-selected'
  | null;

type DownloadExportState = {
  isExporting: boolean;
  exportKind: DownloadExportKind;
  progressLabel: string;
  tryStartExport: (kind: NonNullable<DownloadExportKind>, initialLabel: string) => boolean;
  setProgressLabel: (label: string) => void;
  endExport: () => void;
};

export const useDownloadExportStore = create<DownloadExportState>((set, get) => ({
  isExporting: false,
  exportKind: null,
  progressLabel: '',

  tryStartExport: (kind, initialLabel) => {
    if (get().isExporting) {
      return false;
    }

    set({
      isExporting: true,
      exportKind: kind,
      progressLabel: initialLabel,
    });

    return true;
  },

  setProgressLabel: progressLabel => set({ progressLabel }),

  endExport: () =>
    set({
      isExporting: false,
      exportKind: null,
      progressLabel: '',
    }),
}));
